import { useEffect, useState } from "react";
import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import ActionButton from "../../../Button/ActionButton";
import LayoutWithList from "../../../LayoutModal/WithList";
import Delete from "../../Delete";
import Update from "../Update";
import Loading from "../../../Loading";
import Toast from "../../../../components/Toast";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import useLoading from "../../../../hooks/useLoading";
//Icons
import { PencilSimple, Trash } from "@phosphor-icons/react";
//Interfaces
import { Inputs, IIndex } from "Interfaces/IIndex";
import { ICreate } from "Interfaces/ICreate";

export default function CreateIndice({
  isOpenModal: isOpenModalData,
  setModalClose,
  refreshFrames,
  setToastOpen,
  setToastData
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const {
    isOpenModal,
    toggleModalVisibility
  } = useMultipleModal();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const isUpdateModalOpen = isOpenModal("update");
  const isDeleteModalOpen = isOpenModal("delete");
  const tableHead = ["#", "Índice", "Ações"];
  const [data, setData] = useState<IIndex[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [toastDataUpdate, setToastDataUpdate] = useState({
    status: 200,
    message: "",
  });
  const [hasNewData, setHasNewData] = useState(false);

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`index`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalData) {
      fetchData();
    }
  }, [isOpenModalData]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await apiRequest("index", "POST", data);
      const status = response.status;
      console.log('Response: ', response);
      if (status === 201) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setHasNewData(true);
        setToastOpen(true);
        fetchData();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    }
  };

  const onClose = () => {
    setModalClose();
    reset();

    if (hasNewData) {
      refreshFrames();
      setHasNewData(false);
      toggleModalVisibility('open-toast');
    }
  }

  const handleRefreshFrames = () => {
    fetchData();
    setHasNewData(true);
  };

  if (isOpenModalData) {
    return (
      <LayoutWithList
        title="Registrar Índice"
        subTitle="Cadastre um novo índice em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Índice
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o índice"
                type="number"
                {...register("index", { required: true })}
              />
              {errors.index && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipos Cadastrados</S.TitleList>
          {isLoading ? (
            <Loading />
          ) : (

            <S.Table>
              <thead>
                <tr>
                  {tableHead.map((val) => {
                    return <th>{val}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {data.map((val, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{val.index || "-"}</td>
                      <td>
                        <S.ContentButton>
                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "update")}
                          >
                            <PencilSimple size={20} />
                          </S.ButtonIconTable>

                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "delete")}
                          >
                            <Trash size={20} color="red" />
                          </S.ButtonIconTable>
                        </S.ContentButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </S.Table>
          )}
        </S.Footer>

        <Update
          isOpenModal={isUpdateModalOpen}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          refreshFrames={handleRefreshFrames}
          setToastOpen={() => toggleModalVisibility('open-toast')}
          setToastData={setToastDataUpdate}
        />
        <Toast
          openToast={isOpenModal('open-toast')}
          closeToast={() => toggleModalVisibility('open-toast')}
          message={toastDataUpdate.message}
          status={toastDataUpdate.status}
        />
        <Delete
          updateList={fetchData}
          endpoint="index"
          selectedProductId={openModalOptId}
          isOpenModal={isDeleteModalOpen}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
